import { Route } from '../../config/router'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model'
import { useAppRouter } from '../../state'

export const useAddPaymentLinkHandler = (): (() => void) => {
  const router = useAppRouter()
  const { logEvent } = useMonitoringWithEnduringEventProperties()

  return () => {
    logEvent(TrackingEvent.PRESSED_PAYMENT_METHOD_NEW_CARD)
    router.push(Route.NEW_PAYMENT_METHOD)
  }
}
